import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'qa-edit-block',
  templateUrl: './edit-block.component.html',
  styleUrls: ['./edit-block.component.scss'],
  imports: [MatIcon, TranslateModule],
})
export class EditBlockComponent implements OnInit, OnChanges {
  @ViewChild('editable') editable!: ElementRef<HTMLDivElement>;
  @Output() editBlockValue = new EventEmitter<string>();
  // It is used for when user tries to change value then
  // we can not find original value back because its inline edition in dom. so we need to store it in originalValue and
  // if user clears the fields then we can set original back.
  private originalValue: string;
  @Input() disabled: boolean;
  @Input() label: string;
  @Input() value: string;
  @Input() icon: string;

  ngOnInit() {
    this.originalValue = this.value;
  }

  saveField(event) {
    if (this.disabled) return;
    let newValue = (event.target as HTMLElement).innerText.trim();
    if (newValue) {
      this.value = newValue;
      this.originalValue = newValue;
      this.editBlockValue.emit(newValue);
    } else {
      this.value = this.originalValue;
      this.editable.nativeElement.innerText = this.originalValue;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.disabled) {
      this.disabled = changes.disabled.currentValue;
    }
    if (changes && changes.value) {
      this.originalValue = changes.value.currentValue;
    }
  }
}
